import React from 'react';

import { Alert, Stack, Typography } from '@mui/material';

export default function PriceIntelligenceDecisionFramework() {
  return (
    <Stack gap={1.5} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2 }}>
      <Typography variant="subtitle1" fontWeight={700}>
        Campaign qualification
      </Typography>
      <Typography variant="body2">
        The live return fare must be at or below LE’s lower historical paid-fare benchmark (P25) for adult-only bookings
        over the last 90 days.
      </Typography>
      <Alert severity="info">A missing historical benchmark or unavailable live fare blocks draft creation.</Alert>
      <Typography variant="subtitle2">Every check must pass</Typography>
      <Typography variant="body2">• The selected airline and dates have a current customer fare.</Typography>
      <Typography variant="body2">
        • Corridor margin is positive and cancelled/refunded share is 10% or lower.
      </Typography>
      <Typography variant="body2">• No overlapping campaign or prior rejection blocks this opportunity.</Typography>
      <Typography variant="body2">Drafts require editorial review before publication.</Typography>
    </Stack>
  );
}
